import './index.scss';
import "./import-jquery";
import intlTelInput from 'intl-tel-input';

let script = document.createElement("script");
script.async = true;
script.src = "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js";
document.body.appendChild(script);

// Toggle menu on click
$('#social-media').hide();
$("#menu-toggler").on('click', function() {
    toggleBodyClass("menu-active");
    $('#social-media').fadeToggle();
    $('.helal').slideDown(1000)
    $('.star').slideDown(1300)
});

$('a[href*=\\#]').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
    }, 500, 'linear');
});

function toggleBodyClass(className) {
    document.body.classList.toggle(className);
    $('.helal').hide()
    $('.star').hide()
}
$('.toggled_content').hide();
$('.toggler').on('click', function() {
    $('.toggled_content').slideToggle(500);
});
$('.close-ramadan-modal').on('click', function() {
    $('.modal-ramadan').toggle();
})
if ('serviceWorker' in navigator) {
    // public/v3/dist/browserModern/sw.js
    const sw = `${BASE.url}/ramadan/dist/sw.js`; // it is needed because parcel will not recognize this as a file and not precess in its manner
    navigator.serviceWorker
        .register(sw)
        .then(registration => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            console.log(
                                "New content is available and will be used when all " +
                                "tabs for this page are closed. See https://bit.ly/CRA-PWA."
                            );
                        } else {
                            console.log("Content is cached for offline use.");
                        }
                    }
                };
            };
        })
        .catch(error => {
            console.error("Error during service worker registration:", error);
        });
}